// import heroImage from "../../images/landing/hero-image.png"
import heroImage from "../../images/common/vgc-logo.png"


export const hero = {
  image: heroImage,
  // heroImage,
  title: "Welcome to the Virtual Gaming Community",
  sub: "",
  text: `The premier esports platform for gamers worldwide! Our 11v11 online leagues offer a unique and exciting gaming experience for players of all skill levels.
  `,
}
// ...the premier esports platform for gamers worldwide! Our 11v11 online leagues offer a unique and exciting gaming experience for players of all skill levels.

//   At VGC, we believe in creating a warm and welcoming environment for our community. That's why we have strict content moderation policies in place, ensuring that our platform is family-friendly and safe for all.

//   What sets us apart from other esports platforms? Our user-friendly interface, active and dedicated staff team, and advanced features like automated stats and a fully customizable formation builder make for an unparalleled gaming experience. Plus, our state-of-the-art website is always being maintained and updated by our dedicated development team, ensuring that it is accessible and enjoyable on all devices.

//   So why choose VGC? With our commitment to excellence and inclusivity, we offer the best and most enjoyable gaming experience available. Join us today and see for yourself!
